import Swal from "sweetalert2";

const Alerts = ({ msg, title, code, type, setFunction }) => {
  //Fire Alert
  switch (type) {
    case "assignem_warehouse":{
      
    }break;
    case "delete":{
      return Swal.fire({
        customClass: {
          container: "bg-transparent",
          popup: "bg-grey-glass border-0 rounded-2 p-5 ",
          title: "text-primary fw-normal fs-3",
          icon: "border-0 w-100 mt-5",
        },
        title: '',
        text: "¿Está seguro que desea eliminar?",
        icon: '',
        iconHtml:
        '<svg class="border border-4 border-dark rounded-pill p-3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="90px" height="90px" viewBox="0 0 11 11" version="1.1"><g id="surface1"><path style=" stroke:none;fill-rule:nonzero;fill:rgb(0,0,0);fill-opacity:1;" d="M 4.46875 0.6875 L 6.53125 0.6875 C 6.621094 0.6875 6.710938 0.722656 6.773438 0.789062 C 6.839844 0.851562 6.875 0.941406 6.875 1.03125 L 6.875 1.71875 L 4.125 1.71875 L 4.125 1.03125 C 4.125 0.941406 4.160156 0.851562 4.226562 0.789062 C 4.289062 0.722656 4.378906 0.6875 4.46875 0.6875 Z M 7.5625 1.71875 L 7.5625 1.03125 C 7.5625 0.757812 7.453125 0.496094 7.261719 0.300781 C 7.066406 0.109375 6.804688 0 6.53125 0 L 4.46875 0 C 4.195312 0 3.933594 0.109375 3.738281 0.300781 C 3.546875 0.496094 3.4375 0.757812 3.4375 1.03125 L 3.4375 1.71875 L 1.722656 1.71875 C 1.71875 1.71875 1.71875 1.71875 1.714844 1.71875 L 1.03125 1.71875 C 0.941406 1.71875 0.851562 1.753906 0.789062 1.820312 C 0.722656 1.882812 0.6875 1.972656 0.6875 2.0625 C 0.6875 2.152344 0.722656 2.242188 0.789062 2.304688 C 0.851562 2.371094 0.941406 2.40625 1.03125 2.40625 L 1.402344 2.40625 L 1.988281 9.734375 C 2.015625 10.078125 2.171875 10.402344 2.425781 10.636719 C 2.679688 10.871094 3.011719 11 3.359375 11 L 7.640625 11 C 7.988281 11 8.320312 10.871094 8.574219 10.636719 C 8.828125 10.402344 8.984375 10.078125 9.011719 9.734375 L 9.597656 2.40625 L 9.96875 2.40625 C 10.058594 2.40625 10.148438 2.371094 10.210938 2.304688 C 10.277344 2.242188 10.3125 2.152344 10.3125 2.0625 C 10.3125 1.972656 10.277344 1.882812 10.210938 1.820312 C 10.148438 1.753906 10.058594 1.71875 9.96875 1.71875 L 9.285156 1.71875 C 9.28125 1.71875 9.28125 1.71875 9.277344 1.71875 Z M 8.910156 2.40625 L 8.328125 9.679688 C 8.3125 9.851562 8.234375 10.011719 8.109375 10.128906 C 7.980469 10.246094 7.8125 10.3125 7.640625 10.3125 L 3.359375 10.3125 C 3.1875 10.3125 3.019531 10.246094 2.890625 10.128906 C 2.765625 10.011719 2.6875 9.851562 2.671875 9.679688 L 2.089844 2.40625 Z M 3.761719 3.09375 C 3.851562 3.089844 3.941406 3.121094 4.007812 3.179688 C 4.078125 3.242188 4.117188 3.324219 4.125 3.417969 L 4.46875 9.261719 C 4.472656 9.351562 4.441406 9.4375 4.378906 9.503906 C 4.320312 9.570312 4.234375 9.613281 4.144531 9.617188 C 4.054688 9.621094 3.96875 9.59375 3.898438 9.535156 C 3.832031 9.476562 3.789062 9.390625 3.78125 9.300781 L 3.4375 3.457031 C 3.433594 3.414062 3.441406 3.367188 3.457031 3.324219 C 3.46875 3.28125 3.492188 3.242188 3.523438 3.207031 C 3.554688 3.175781 3.589844 3.148438 3.628906 3.128906 C 3.671875 3.109375 3.714844 3.097656 3.761719 3.09375 Z M 7.238281 3.09375 C 7.285156 3.097656 7.328125 3.109375 7.367188 3.128906 C 7.410156 3.148438 7.445312 3.175781 7.476562 3.207031 C 7.507812 3.242188 7.527344 3.28125 7.542969 3.324219 C 7.558594 3.367188 7.566406 3.414062 7.5625 3.457031 L 7.21875 9.300781 C 7.214844 9.347656 7.207031 9.390625 7.1875 9.433594 C 7.167969 9.476562 7.140625 9.511719 7.105469 9.542969 C 7.070312 9.574219 7.03125 9.597656 6.988281 9.613281 C 6.945312 9.628906 6.898438 9.632812 6.855469 9.632812 C 6.808594 9.628906 6.765625 9.617188 6.722656 9.597656 C 6.683594 9.578125 6.644531 9.546875 6.613281 9.511719 C 6.585938 9.480469 6.5625 9.4375 6.546875 9.394531 C 6.535156 9.351562 6.527344 9.304688 6.53125 9.261719 L 6.875 3.417969 C 6.882812 3.324219 6.921875 3.242188 6.992188 3.179688 C 7.058594 3.121094 7.148438 3.089844 7.238281 3.09375 Z M 5.5 3.09375 C 5.589844 3.09375 5.679688 3.128906 5.742188 3.195312 C 5.808594 3.257812 5.84375 3.347656 5.84375 3.4375 L 5.84375 9.28125 C 5.84375 9.371094 5.808594 9.460938 5.742188 9.523438 C 5.679688 9.589844 5.589844 9.625 5.5 9.625 C 5.410156 9.625 5.320312 9.589844 5.257812 9.523438 C 5.191406 9.460938 5.15625 9.371094 5.15625 9.28125 L 5.15625 3.4375 C 5.15625 3.347656 5.191406 3.257812 5.257812 3.195312 C 5.320312 3.128906 5.410156 3.09375 5.5 3.09375 Z M 5.5 3.09375 "/></g></svg>',
        showCancelButton: true,
        confirmButtonColor: '#FAB428',
        cancelButtonColor: '#000000',
        confirmButtonText: 'SI',
        cancelButtonText: 'NO'
      }).then((result) => {
        if (result.isConfirmed) {
          setFunction();

          return Swal.fire({
            customClass: {
              container: "bg-transparent",
              popup: "bg-grey-glass border-0 rounded-2 p-5 ",
              title: "text-dark fw-normal fs-3",
              icon: "bg-transparent"
            },
            showConfirmButton: false,
            icon: "success",
            title: "Eliminado!"
          }
          )
        }
      })
    } break;
    case "arrival":{
      return Swal.fire({
        position: 'center',
        icon: "",
        customClass: {
          container: "bg-transparent",
          popup: "bg-white border border-primary rounded-2 p-5 content-reverse-alert",
          title: "text-primary fw-normal fs-4",
          icon: "border-0 w-100 mt-5 reverse-icon",
        },
        iconHtml:
        '<div class="border border-4 border-primary  rounded-pill p-2"><svg class=" mx-2 bi bi-truck" xmlns="http://www.w3.org/2000/svg" width="70" height="70" fill="#F16A1B"  viewBox="0 0 16 16"><path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/></svg></div>',
        title: "Has llegado al depósito a las "+title,
        showConfirmButton: false,
      })
    } break;
    case "exito":{
      return Swal.fire({
        position: 'center',
        icon: "",
        customClass: {
          container: "bg-transparent  bg-glass",
          popup: "bg-white border border-primary rounded-2 p-5 content-reverse-alert",
          title: "text-primary fw-normal fs-5",
          icon: "border-0 border-primary w-100 mt-5 reverse-icon",
        },
        iconHtml:
        '<div class="border-0 w-100"><svg width="70" height="70" viewBox="0 0 24 24" fill="#FAB428" xmlns="http://www.w3.org/2000/svg"><path d="M22.5254 11.2617C22.5254 16.7857 18.0484 21.2617 12.5254 21.2617C7.00239 21.2617 2.52539 16.7857 2.52539 11.2617C2.52539 5.73972 7.00239 1.26172 12.5254 1.26172C18.0484 1.26172 22.5254 5.73972 22.5254 11.2617Z" fill="#F16A1B"/><path d="M10.761 17C10.4328 17 10.1045 16.8692 9.85383 16.6059L6.37593 12.9532C5.87469 12.4268 5.87469 11.574 6.37593 11.0491C6.87717 10.5227 7.68765 10.5211 8.1889 11.0476L10.761 13.749L16.8111 7.39483C17.3123 6.86839 18.1228 6.86839 18.6241 7.39483C19.1253 7.92127 19.1253 8.77403 18.6241 9.30047L11.6683 16.6059C11.4176 16.8692 11.0893 17 10.761 17Z" fill="white"/></svg></div>',
        title: title,
        showConfirmButton: false,
      })
    } break;
    case "success":
      {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: false,
          customClass: {
            container: "",
            popup: "bg-grey border border-success",
            title: "text-success",
            icon:  "border-0",
          },

          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
        
        Toast.fire({
          keydownListenerCapture: true,
          allowOutsideClick: true,
          iconHtml:
          '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5254 11.2617C22.5254 16.7857 18.0484 21.2617 12.5254 21.2617C7.00239 21.2617 2.52539 16.7857 2.52539 11.2617C2.52539 5.73972 7.00239 1.26172 12.5254 1.26172C18.0484 1.26172 22.5254 5.73972 22.5254 11.2617Z" fill="#12703A"/><path d="M10.761 17C10.4328 17 10.1045 16.8692 9.85383 16.6059L6.37593 12.9532C5.87469 12.4268 5.87469 11.574 6.37593 11.0491C6.87717 10.5227 7.68765 10.5211 8.1889 11.0476L10.761 13.749L16.8111 7.39483C17.3123 6.86839 18.1228 6.86839 18.6241 7.39483C19.1253 7.92127 19.1253 8.77403 18.6241 9.30047L11.6683 16.6059C11.4176 16.8692 11.0893 17 10.761 17Z" fill="white"/></svg>',
          icon: '',
          title: title
        })
      }
      break;
    case "error":
      {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: false,
          customClass: {
            container: "",
            popup: "bg-grey border border-danger",
            title: "text-danger",
            icon:  "",
          },

          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
        
        Toast.fire({
          keydownListenerCapture: true,
          allowOutsideClick: true,
          icon: 'error',
          title: title
        })
      }
      break;
    case "warning":
      {
        const Toast = Swal.mixin({
          toast: true,
          position: 'top',
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: false,
          customClass: {
            container: "",
            popup: "bg-grey border border-warning",
            title: "text-warning",
            icon:  "",
          },

          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
        
        Toast.fire({
          keydownListenerCapture: true,
          allowOutsideClick: true,
          icon: 'warning',
          title: title
        })
      }
      break;
  }

  return null;
};

export default Alerts;
